var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfoSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 3.49596,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_614_78651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 20.8346C11.7796 20.8346 9.16797 18.2231 9.16797 15.0013C9.16797 11.7796 11.7796 9.16797 15.0013 9.16797C18.2231 9.16797 20.8346 11.7796 20.8346 15.0013C20.8346 18.2231 18.2231 20.8346 15.0013 20.8346ZM15.0013 19.668C16.239 19.668 17.426 19.1763 18.3011 18.3011C19.1763 17.426 19.668 16.239 19.668 15.0013C19.668 13.7636 19.1763 12.5766 18.3011 11.7015C17.426 10.8263 16.239 10.3346 15.0013 10.3346C13.7636 10.3346 12.5766 10.8263 11.7015 11.7015C10.8263 12.5766 10.3346 13.7636 10.3346 15.0013C10.3346 16.239 10.8263 17.426 11.7015 18.3011C12.5766 19.1763 13.7636 19.668 15.0013 19.668ZM14.418 12.0846H15.5846V13.2513H14.418V12.0846ZM14.418 14.418H15.5846V17.918H14.418V14.418Z",
    fill: "#585858"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_614_78651"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSolid);
export default __webpack_public_path__ + "static/media/info_solid.9b76d09a5aa8e9bfd0377e9f4d0c44ec.svg";
export { ForwardRef as ReactComponent };